package ui.external.materialui

object DividerVariant {
    const val fullWidth = "fullWidth"
}
